import { render, staticRenderFns } from "./BookingSlot.vue?vue&type=template&id=06fd93a4&scoped=true&"
import script from "./BookingSlot.vue?vue&type=script&lang=js&"
export * from "./BookingSlot.vue?vue&type=script&lang=js&"
import style0 from "./BookingSlot.vue?vue&type=style&index=0&id=06fd93a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fd93a4",
  null
  
)

export default component.exports